import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';
import {sharedComponent} from '@lib/utils';
import {createApplicationState} from '@services/ApplicationState';
import {IApplicationState} from '@services/types';

@sharedComponent
export class HamburgerButton extends ConnectedComponent {
  private appService: IApplicationState = createApplicationState();

  open() {
    this.appService.updateIsOpenGlobalNav(true);
    this.element?.classList.add('open');
  }

  close() {
    setTimeout(() => {
      this.appService.updateIsOpenGlobalNav(false);
      this.element?.classList.remove('open');
    }, 100);
  }

  isOpen() {
    return this.element?.classList.contains('open');
  }

  didMount() {
    this.observe(appSelectors.selectPageIndicatorStatus, (status) => {
      if (status === 'endShowAnimation') {
        this.close();
      }
    });

    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'startHideAnimation') {
        this.element?.classList.add('viewed');
      }
    });

    this.observe(appSelectors.selectFirstViewStatus, async (status) => {
      if (status === 'scrolled') {
        // this.element?.classList.add('scrolled');
      } else {
        // this.element?.classList.remove('scrolled');
      }
    });

    // this.observe(appSelectors.selectIsOpenGlobalNav, async (isOpen) => {
    //   isOpen
    //     ? this.element?.classList.add('open')
    //     : this.element?.classList.remove('open');
    // });

    this.on('mouseenter', () => {
      this.element?.classList.add('hover');
    });
    this.on('mouseleave', () => {
      this.element?.classList.remove('hover');
    });

    this.on('click', () => {
      if (this.element?.classList.contains('open')) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  down() {
    this.element?.classList.add('down');
  }

  up() {
    this.element?.classList.remove('down');
  }
}
